import { useSearchParams } from "next/navigation"
import React from "react"

import LoanOptions from "../../components/loan-options"
import { useSession } from "../session-context"
import { StepProps } from "../step-registry"

const LoanOptionsStep: React.FC<StepProps> = ({ onComplete }) => {
  const { sessionData, updateSession } = useSession()
  const searchParams = useSearchParams()
  const variantId = searchParams.get("variantId")

  const handleOrderComplete = () => {
    updateSession({ progress: { ...sessionData.progress, hasOrderBeenPlaced: true } })
    onComplete()
  }

  const handleServerError = () => {
    updateSession({ progress: { ...sessionData.progress, serverErrorOccurred: true } })
    onComplete()
  }

  const handleCartTotalChange = (total: number) => {
    updateSession({ product: { ...sessionData.product, cartTotal: total } })
  }

  return (
    <LoanOptions
      variantId={variantId}
      onComplete={handleOrderComplete}
      onServerError={handleServerError}
      onCartTotalChange={handleCartTotalChange}
      preSelectedInstallment={sessionData.product.preSelectedInstallment}
    />
  )
}

export default LoanOptionsStep
